module.exports = __webpack_public_path__ + "static/img/cert.47a1b011.png";